import pxToRem from './pxtorem'
import color from './color'
import * as ie from './ie'
import * as format from './format'
import normalize from './normalize'
import * as permissions from './permissions'
import * as patterns from './patterns'
import * as timestamp from './timestamp'
import * as downloads from './downloads'
import { captions } from './captions'
import { monthsNames } from './monthsNames'
import * as numberFormater from './numberFormater'
import { dateToBrFormat } from './dateToBrFormat'
import { productFullName } from './productFullName'


export {
  pxToRem,
  color,
  format,
  normalize,
  ie,
  permissions,
  patterns,
  timestamp,
  downloads,
  captions,
  monthsNames,
  numberFormater,
  dateToBrFormat,
  productFullName
}



// WEBPACK FOOTER //
// ./src/utils/index.js